/* export default {
  apiKey: process?.env?.VUE_APP_FIREBASE_API_KEY || '',
  authDomain: process?.env?.VUE_APP_FIREBASE_AUTH_DOMAIN || '',
  databaseURL: process?.env?.VUE_APP_FIREBASE_DATABASE_URL || '',
  storageBucket: process?.env?.VUE_APP_FIREBASE_STORAGE_BUCKET || '',
  projectId: process?.env?.VUE_APP_FIREBASE_PROJECT_ID || '',
  messagingSenderId: process?.env?.VUE_APP_FIREBASE_MESSAGING_SENDER_ID || '',
  appId: process?.env?.VUE_APP_FIREBASE_APP_ID || '',
} */

export default {
  apiKey: "AIzaSyBm9D0yw-XARu8tnvbnnjyFa2Q6PHqsO4I",
  authDomain: "sosapp-bd22b.firebaseapp.com",
  databaseURL: "https://sosapp-bd22b.firebaseio.com",
  storageBucket: "sosapp-bd22b.appspot.com",
  projectId: "sosapp-bd22b",
  messagingSenderId: "46847331449",
  appId: "1:46847331449:web:ec4d7d6840dd0e615c18a8",
}
